// extracted by mini-css-extract-plugin
export default {"heroContainer":"Contact_heroContainer__mVFLW","overlay":"Contact_overlay__QGR8e","title":"Contact_title__x8SZB","typing":"Contact_typing__jnqPE","blink":"Contact_blink__7sjlA"};